import SortArrows from '../../components/icons/sort-arrows.jsx';
import { setSorting, setCheckedItems } from '../../store/promoSlice';

export const getHeaders = (
    sortBy,
    sortDirection,
    dispatch,
    sortArrowColorActive,
    sortArrowColorInactive,
    rowsData,
    checkedItems
) => {
    const allIds = rowsData.map((row) => row.id);
    const allChecked = rowsData.length > 0 && checkedItems.length > 0 && allIds.every((id) => checkedItems.includes(id));

    return [
        <label
            key="promo-header-checkbox"
            className="checkbox-wrapper"
            onClick={(e) => e.stopPropagation()}
        >
            <input
                type="checkbox"
                checked={allChecked}
                onChange={(e) => {
                    if (e.target.checked) {
                        dispatch(setCheckedItems([...new Set([...checkedItems, ...allIds])]));
                    } else {
                        dispatch(setCheckedItems(checkedItems.filter((id) => !allIds.includes(id))));
                    }
                }}
            />
        </label>,
        <div key="promo-header-id" className="table-columns-headers">
            <div>ID</div>
            <SortArrows
                upColor={sortBy === 'id' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'id' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('id', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="promo-header-date" className="table-columns-headers">
            <div>Data</div>
            <SortArrows
                upColor={sortBy === 'date' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'date' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('date', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="promo-header-event" className="table-columns-headers">
            <div>Nazwa wydarzenia</div>
            <SortArrows
                upColor={sortBy === 'eventName' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'eventName' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('eventName', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="promo-header-organizer" className="table-columns-headers">
            <div>Organizator</div>
            <SortArrows
                upColor={sortBy === 'organizer' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'organizer' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('organizer', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="promo-header-type" className="table-columns-headers">
            <div>Rodzaj promowania</div>
            <SortArrows
                upColor={sortBy === 'promotionType' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'promotionType' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('promotionType', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="promo-header-amount" className="table-columns-headers">
            <div>Kwota (pln)</div>
            <SortArrows
                upColor={sortBy === 'amount' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'amount' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('amount', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="promo-header-transaction" className="table-columns-headers">
            <div>Transakcja</div>
            <SortArrows
                upColor={sortBy === 'transaction' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
                downColor={sortBy === 'transaction' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
                className="menu-icon"
                onClick={() => handleSort('transaction', sortBy, sortDirection, dispatch)}
            />
        </div>,
        <div key="promo-header-status">Status</div>,
        <div key="promo-header-actions">Akcje</div>,
    ];
};

const handleSort = (columnName, sortBy, sortDirection, dispatch) => {
    if (sortBy !== columnName) {
        dispatch(setSorting({ sortBy: columnName, sortDirection: 'ASC' }));
    } else {
        if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: columnName, sortDirection: 'DESC' }));
        } else {
            dispatch(setSorting({ sortBy: null, sortDirection: null }));
        }
    }
};

export const headerWidths = [
    '56px',
    '64px',
    '120px',
    '1.4fr',
    '1fr',
    '170px',
    '120px',
    '120px',
    '110px',
    '96px',
];

export const empty = [];
